import { render, staticRenderFns } from "./Confirmed.vue?vue&type=template&id=32a27dcf&scoped=true&"
import script from "./Confirmed.vue?vue&type=script&lang=js&"
export * from "./Confirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a27dcf",
  null
  
)

export default component.exports